import styled from 'styled-components';

const Bold = styled.div`
  display: inline-block;
  font-weight: 700;
`;

export default Bold;
